import { Icon } from 'antd';
import styled from 'styled-components';
export const RotateIcon = styled(Icon) `
  &&& {
    color: rgba(0, 0, 0, 0.25);

    svg {
      font-size: 0.9rem;
      transition: transform 0.3s ease;
    }
  }
`;
